<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="btn" @click="categoryModal('add', { isFirst: true })">
          + 添加一级菜单
        </div>
        <el-table
          :data="menuList"
          class="goods-category-table table no-border-table"
          :tree-props="{ children: 'second', hasChildren: 'hasChildren' }"
          row-key="tid"
          border
          ref="orderTable"
          :header-cell-style="{
            color: '#666',
            fontSize: '14px',
            background: '#FAFAFA',
            borderBottom: '1px solid #F0F0F0',
            height: '44px',
          }"
          :row-style="{
            height: '44px',
          }"
        >
          <!-- <el-table-column
            type="index"
            :index="tableIndex"
            align="center"
            label="编号"
            width="120"
          ></el-table-column> -->
          <el-table-column align="center" label="" width="60"></el-table-column>
          <el-table-column prop="name" align="center" label="菜单名称">
          </el-table-column>
          <!-- <el-table-column prop="pic" align="center" label="图片">
            <div slot-scope="scope">
              <img
                class="img"
                v-if="scope.row.onePic"
                :src="scope.row.isFirst ? scope.row.onePic : scope.row.twoPic"
                alt=""
              />
              <span v-else>--</span>
            </div>
          </el-table-column> -->
          <el-table-column prop="path" align="center" label="前端路由">
          </el-table-column>
          <el-table-column
            prop="rank"
            align="center"
            label="排序"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="300">
            <div slot-scope="scope" class="table-btn-box">
              <button
                size="mini"
                v-if="scope.row.isFirst"
                class="table-btn"
                @click="categoryModal('addChildren', scope.row)"
              >
                + 添加二级菜单
              </button>
              <button
                size="mini"
                class="table-btn"
                @click="deleteMenu(scope.row.id, scope.row.isFirst)"
              >
                删除
              </button>
              <button
                size="mini"
                class="table-btn"
                @click="categoryModal('edit', scope.row)"
              >
                编辑
              </button>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <!-- <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div> -->
    </div>
    <!-- 发布公告弹窗 -->
    <el-dialog width="480px" :visible.sync="menuShow">
      <div slot="title">
        <p class="dialog-title">
          {{ type === "edit" ? "编辑" : "添加"
          }}{{ firstInfo.id ? "二级" : "一级" }}菜单
        </p>
      </div>
      <div class="dialog-content">
        <el-form
          ref="form"
          :rules="rules"
          :model="form"
          label-position="top"
          class="category-form"
          label-width="auto"
        >
          <el-form-item
            v-if="firstInfo.pid"
            label="父级菜单："
            prop="name"
            class="form-item"
          >
            <el-input
              placeholder="请输入分类名称"
              class="input"
              size="small"
              disabled
              v-model="form.twoName"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="名称："
            prop="name"
            class="form-item"
            v-if="!firstInfo.pid"
          >
            <el-input
              placeholder="请输入"
              class="input"
              size="small"
              v-model="form.name"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item
            label="二级分类名称："
            prop="twoName"
            class="form-item"
            v-else
          >
            <el-input
              placeholder="请输入分类名称"
              class="input"
              size="small"
              v-model="form.twoName"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="前端路由:" prop="name" class="form-item">
            <el-input
              placeholder="请输入"
              class="input"
              size="small"
              v-model="form.path"
            ></el-input>
          </el-form-item>
          <el-form-item label="序号：" prop="twig" class="form-item">
            <el-input
              placeholder="请输入"
              class="input"
              v-model.number="form.rank"
              type="number"
              size="small"
              onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
            ></el-input>
            <!-- <div class="tip">
              数值越大，排序越靠前
            </div> -->
          </el-form-item>
          <el-form-item
            class="img_item"
            v-if="!firstInfo.id"
            prop="icon"
            label="菜单图标："
          >
            <div class="addImg" style="margin-top: 5px;">
              <div class="img-box">
                <img ref="img" :src="form.icon" v-if="form.icon" />
                <div class="icon" v-else>
                  <p><i class="el-icon-plus" style="font-size: 32px"></i></p>
                  <!-- <p>图片</p> -->
                  <!-- <p class="tip">支持扩展名：.jpg .png</p> -->
                </div>
                <input
                  type="file"
                  class="file"
                  ref="inputImg"
                  @change="addChangeImg"
                />
              </div>
              <p class="tips">推荐尺寸32*32px</p>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <button
          class="btn cancel-btn"
          size="small"
          @click="menuShow = false"
        >
          取 消
        </button>
        <button class="btn confirm-btn" size="small" @click="handleConfirm">
          确 定
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import dayjs from 'dayjs';
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'goods-category',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 9999, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '权限管理',
        secondTitle: '菜单管理'
      },
      type: '', // edit：修改  add：添加
      menuInfo: {}, // 公告信息
      menuList: [], // 公告列表
      menuShow: false, // 公告弹窗
      firstInfo: {},
      form: {
        // 表单数据
        name: '',
        path: '',
        rank: null,
        pid: null,
        icon: ''
      },
      rules: {
        // 表单验证规则
        // name: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        // twig: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        // pic: [{ required: true, message: '请输入内容', trigger: 'change' }]
      }
    };
  },
  mounted() {
    // 获取列表
    this.getMenuList();
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  computed: {},
  methods: {
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getMenuList();
    },
    // 获取分区列表
    getMenuList() {
      this.loading++;
      this.httpGet(this.$root.menuList, {
        page: this.currentPage,
        size: this.size
      }).then(
        (res) => {
          this.loading--;
          this.menuList = res.list.map((item, index) => {
            return {
              ...item.menu,
              index: ++index,
              isFirst: true,
              tid: item.menu.id,
              second: item.sub.map((sec) => {
                return {
                  ...sec,
                  // fName: item.oneName,
                  tid: item.menu.id + '-' + sec.id
                };
              })
            };
          });
          console.log(this.menuList);
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 公告弹窗
    categoryModal(type, rowData = {}) {
      this.$refs.form && this.$refs.form.clearValidate();
      this.type = type;
      this.firstInfo = {};

      console.log(rowData);

      if(type === 'add' || (type === 'edit' && rowData.isFirst)){
        this.form = {
          name: rowData.name || '',
          icon: rowData.icon || '',
          rank: rowData.rank || null,
          path: rowData.path || '',
          id: rowData.id
        }
      } else if(type === 'addChildren'){
        this.firstInfo = rowData;
        this.form = {
          rank: null,
          pid: rowData.id,
          name: '',
          icon: '',
          path: '',
        }
      } else {
        this.firstInfo = {
          oneName: rowData.fName,
          id: rowData.pid
        };
        this.form = {
          pid: rowData.pid,
          path: rowData.path,
          name: rowData.name,
          rank: rowData.rank,
          icon: rowData.icon,
          id: rowData.id
        }
      }
      this.menuShow = true;
    },
    // 确认发布/修改公告
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading++;
          // let inputData = {};
          let url = '', methods = 'httpPost';
          if (this.type === 'edit') {
            url = this.$root.editMenu;
            methods = 'httpPut';
            // inputData = this.form;
          } else {
            url = this.$root.addMenu;
            // inputData = this.form;
          }
          this.menuShow = false;
          this[methods](url, this.form).then(
            (res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.loading--;
              this.getMenuList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        } else {
          return false;
        }
      });
    },
    // 删除分区
    deleteMenu(id, isFirst) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该菜单吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteMenu, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getMenuList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 图片改变
    addChangeImg(e) {
      this.upPic(e, (res) => {
        this.$set(this.form, 'onePic', res);
        // 清空input value，解决重复图片不触发change
        this.$refs.inputImg.value = '';
        this.$refs.form.clearValidate(['onePic']);
      });
    },
    // 上传图片
    upPic(e, fun) {
      // 上传图片
      let file = e.target.files[0];
      if (!file) {
        return;
      }
      this.request.upPic({ prefix: 'other', file: file }).then(
        (res) => {
          fun(res);
        },
        (res) => {}
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

>>>.el-form-item__label{
  padding: 0;
  height: 20px;
  line-height: 20px;
}

.page-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    padding: 0 20px 20px;

    // content 表格
    .content {

      .checked-icon {
        color: btn-color;
        font-size: 16px;
      }

      .no-checked-icon {
        display: inline-block;
        color: #aaa;
        border: 1px solid #aaa;
        background: #eee;
        width: 15px;
        height: 15px;
        border-radius: 3px;
        box-sizing: border-box;
      }

      // 按钮
      .btn {
        // width: 100px;
        padding: 0 15px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
      }

      .table {
        .img {
          height: 48px;
          width: auto;
        }

        .table-children {
          transform: translateX(40%);
          white-space: nowrap;
        }
      }

      // 表格按钮
      // .table-btn {
      //   width: 80px;
      //   height: 24px;
      //   line-height: 24px;
      //   color: gray3;
      //   font-size: 12px;
      //   margin-right: 8px;
      //   cancel-btn();
      // }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .dialog-content {
    flex-y();

    .addImg {
      flex-x(flex-start);

      .icon {
        width: 81px;
        height: 81px;
        background: #E8E8E8;
        border-width: 0;

        i {
          color: #999;
        }
      }

      .tips {
        align-self: flex-end;
        margin-left: 8px;
      }
    }

    .tip {
      margin-top: 0;
    }

    .tip {
      word(14px, #C8C8C8);
      line-height: 24px;
      margin: 0;
    }

    .input {
      width: 160px;
    }
  }

  .category-form {
    // padding: 32px 0 10px;
    width: 100%;
    .input{
      width: 100%;
    }
  }
}
</style>
